// extracted by mini-css-extract-plugin
module.exports = {"container":"_0fce717cdb--container--fo3iO","chat-container":"_0fce717cdb--chat-container--hV4km","jump":"_0fce717cdb--jump--joYmu"};